/* eslint-disable jsx-a11y/iframe-has-title */
import { Modal } from '@/components/common/dialog';
import type { ListTypeListItem } from '@/types/list-type';
import clsx from 'clsx';
import styles from './styles.module.scss';
import { useConfigStore } from '@/stores/configStore';
import { useOrientation } from '@/hooks';
import { useTranslation } from 'react-i18next';

const PopupEventDetail = ({ content, isOpen, onClose }: { content?: ListTypeListItem; isOpen: boolean; onClose: () => void }) => {
    const { t } = useTranslation();

    const screenMode = useConfigStore((s) => s.config?.ui?.screenMode);
    const { isHorizontal } = useOrientation();
    const isHalfmodeVertical = screenMode === 'split' && !isHorizontal;

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            className={clsx(styles['event-detail'], {
                [styles['event-detail__fullscreen']]: isHorizontal && screenMode === 'fullscreen',
                [styles['event-detail__vertical--halfmode']]: isHalfmodeVertical,
                [styles['event-detail__vertical']]: !isHorizontal && screenMode === 'fullscreen',
            })}
            scrollBarClassName="max-h-full! overflow-y-hidden!"
            wrapperClassName={clsx('items-center! pb-0!', styles['event-detail__backdrop'])}
            closeTabIndex={2}
            closeRegionOrder={2}
        >
            <div
                data-interactive
                data-modal-region
                data-modal-region-order={1}
                tabIndex={1}
                className="focus-border"
                aria-label={t('custom_menu.detail_popup', { title: content?.title })}
            >
                <iframe src={content?.qrUrl} sandbox="allow-same-origin allow-scripts"></iframe>
            </div>
        </Modal>
    );
};

export default PopupEventDetail;
